var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,13c-4.98,0-9,4.02-9,9s4.02,9,9,9,9-4.02,9-9-4.02-9-9-9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,0H13C5.83,0,0,5.83,0,13v18c0,7.17,5.83,13,13,13h18c7.17,0,13-5.83,13-13V13c0-7.17-5.83-13-13-13ZM22,33c-6.06,0-11-4.94-11-11s4.94-11,11-11,11,4.94,11,11-4.94,11-11,11ZM34,12c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconWhite);
export default __webpack_public_path__ + "static/media/instagram-icon-white.1008530753dacba37f403d1e148163e4.svg";
export { ForwardRef as ReactComponent };